// Job-type labels for the activity log, and the rule that maps a log row onto a
// pipeline stage.
//
// A log row carries job_type but not pipeline_stage, so the active stage has to be
// derived. It is derived by matching the label against the stage NAME the backend
// returns -- not by a job-type-to-stage-index map, which would hardcode the stage list
// a second time and reintroduce the bug that hid Rollover in the first place.

export const TYPE_LABELS = {
  data_import: "Import",
  data_load: "Import",
  data_transform: "Transform",
  allocation: "Allocation",
  data_forecast: "Forecast",
  period_rollover: "Rollover",
  report_generation: "Report",
  pipeline: "Pipeline",
};

// Returns the `stage` number whose name matches the job type's label, or null when the
// job type is unmapped or no stage matches. Null means "highlight nothing" -- the strip
// still renders every stage.
export function resolveActiveStage(stages, jobType) {
  const label = TYPE_LABELS[jobType];
  if (!label || !Array.isArray(stages)) return null;
  const match = stages.find(
    (s) => (s.name || "").toLowerCase() === label.toLowerCase()
  );
  return match ? match.stage : null;
}
